export default __webpack_public_path__ + "static/organization_chart-7feae3f37fc3401cc40f1f4fd0758764.png";